import { request } from '@blade/common';
/**
 * 获取所有人像库
 * @returns 返回所有可用人像库
 */
export const getlibraries = (data) => (request({
    url: '/api/portrait-management/api/v1/portraitlib/list',
    method: 'POST',
    data
}));
/**
 * 1:1获取人像对比结果
 * @returns 对比结果
 */
export const getCompareResult = (data) => (request({
    url: '/api/portrait-management/api/v1/portrait/tool/image/compare',
    method: 'POST',
    data
}));
/**
 * 从图像中检测并提取所有特征
 * @param image 原始图片base64地址
 * @returns 人像列表
 */
export const getDetect = (image) => (request({
    url: '/api/portrait-management/api/v1/portrait/tool/image/detect',
    method: 'POST',
    data: {
        image,
    }
}));
/**
 * 1:N人像对比结果
 * @param data 请求参数
 * @returns 对比结果
 */
export const getSearchResult = (data) => (request({
    url: '/api/portrait-management/api/v1/portrait/tool/image/search/page',
    method: 'POST',
    data
}));
/**
 * 人像列表查询请求
 * @param data 请求参数
 * @returns 人像列表
 */
export const getPortraitList = (data) => (request({
    url: '/api/portrait-management/api/v1/portrait/pagequery',
    method: 'POST',
    data
}));
